__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/6219803/_next/";